<template>
  <div class="locations">
    <!-- Banner区域 -->
    <div class="locations-bg">
      <div class="locations-bg-img">
        <img src="@/assets/home/banner.png" alt="locations Banner">
      </div>
      <div class="locations-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('locations.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('locations.breadcrumb.activeTitle') }}</li>
          </ol>
        </nav>
      </div>
      <div class="locations-bg-position"></div>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
      <div class="locations-title">
        <h1>{{ $t('home.oneCont.title') }}</h1>
        <p>{{ $t('home.oneCont.cont') }}</p>
        <!-- <div class="carousel-caption-btn button--ujarak" @click="$router.push({ path: '/about' })">{{ $t('home.oneCont.btn') }}</div> -->
      </div>
    </div>

    <div class="home-locations">
      <div class="home-locations-div">
        <div class="area-title-pc">
          <p>{{ locationsList[0]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ locationsList[0]?.value[0]?.subheading }}</p>
        </div>
        <div class="home-locations-cont">
          <div class="home-locations-map">
            <div class="home-locations-map-item">
              <!-- Google Maps 组件 -->
              <GmapMap
                :center="center"
                :zoom="zoom"
                style="width: 100%; height: 100%"
                :options="{ disableDefaultUI: true }"
              >
                <!-- 地图标记点 -->
                <GmapMarker
                  v-for="(marker, index) in locationsList[0]?.value[0]?.content"
                  :key="index"
                  :position="marker.latitude_and_longitude"
                  :icon="{
                    url: require('@/assets/home/dw.png'),
                    scaledSize: { width: 50, height: 50 }
                  }"
                  @click="onMarkerClick(marker)"
                />
                <!-- 用户当前位置标记 -->
                <GmapMarker
                  v-if="userLocation"
                  :position="userLocation"
                  :icon="userIcon"
                />

                <!-- 信息窗口 -->
                <GmapInfoWindow
                  v-if="selectedMarker"
                  :options="{ maxWidth: '500',width:'500' }"
                  :position="selectedMarker.latitude_and_longitude"
                  @closeclick="onInfoWindowClose"
                  :visible="isInfoWindowVisible"
                >
                  <div class="info-window-content">
                    <div class="info-window-avater">
                      <img :src="selectedMarker.icon" alt="">
                    </div>
                    <div class="info-window-titleCont">
                      <h5>{{ selectedMarker.name }}</h5>
                      <span>{{ selectedMarker.url }}</span>
                    </div>
                    <div class="info-window-body">
                      <div class="info-window-footer">
                        <button @click="navigateToLocation(selectedMarker)">
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </GmapInfoWindow>
              </GmapMap>
            </div>
            <div class="home-locations-map-item home-locations-map-item-list">
              <div class="locations-list">
                <el-card class="locations-list-card" v-for="(item, index) in locationsList[0]?.value[0]?.content" :key="index">
                  <div class="info-window-card-content">
                    <div class="info-window-card-avater">
                      <img :src="item.icon" alt="">
                    </div>
                    <div class="info-window-card-titleCont">
                      <h5>{{ item.name }}</h5>
                      <p>{{ $t('franchise.countries.label') + ' ' + item.url }}</p>
                      <p>{{ $t('franchise.countries.label1') + ' ' + item.mobile }}</p>
                    </div>
                    <div class="info-window-card-body">
                      <div class="info-window-card-footer">
                        <button @click="navigateToLocation(item)">
                          <i class="el-icon-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/utils/bus'
import { getBannerListing,getDataList } from '@/api/komo'
export default {
  name: 'locations',
  data() {
    return {
      bannerList: [], //
      locationsList: [],
      // locations ================================
      center: { lat: 1.3521, lng: 103.8198 }, // 新加坡坐标
      zoom: 6,
      selectedMarker: null,
      userLocation: null,
      isInfoWindowVisible: true,
      userIcon: {
        url: require('@/assets/home/dqdw.png'),
        scaledSize: { width: 88, height: 88 }
      },
      markers: [
        {
          name: '新加坡',
          position: { lat: 1.3521, lng: 103.8198 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '新加坡共和国'
        },
        {
          name: '马来西亚',
          position: { lat: 3.1497, lng: 101.6942 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '马来西亚联邦'
        },
        {
          name: '泰国',
          position: { lat: 13.7563, lng: 100.5018 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '泰王国'
        },
        {
          name: '印度尼西亚',
          position: { lat: -6.2088, lng: 106.8456 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '印度尼西亚共和国'
        },
        {
          name: '巴西',
          position: { lat: -53.8496, lng: -8.8856 },
          icon: {
            url: require('@/assets/home/dw.png'),
            scaledSize: { width: 50, height: 50 }
          },
          description: '巴西'
        }
      ]

      // locations end ================================
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    async initData () {
      const result = await getBannerListing('5');
      this.bannerList = result.data.list;

      const locationsDatalist = await getDataList(localStorage.getItem('pageId'));
      this.locationsList = locationsDatalist.data.list;
      this.locationsList[0]?.value[0]?.content.forEach(item => { 
        try {
          if (item.latitude_and_longitude) {
            const coords = item.latitude_and_longitude.split(',')
            if (coords.length === 2) {
              item.latitude_and_longitude = {
                lat: parseFloat(coords[0].trim()),
                lng: parseFloat(coords[1].trim())
              }
            }
          }
        } catch (e) {
          console.error('经纬度转换错误:', e)
          item.coordinates = null
        }
      })
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
    // 获取用户当前位置
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            
            this.userLocation = { lat, lng };
            this.center = { lat, lng };
            this.zoom = 1.5;
            
            console.log('用户位置:', lat, lng);
          },
          (error) => {
            console.error('获取位置失败:', error);
            alert('无法获取您的位置，请检查浏览器设置');
          },
          {
            enableHighAccuracy: true, // 高精度
            timeout: 10000, // 超时时间
            maximumAge: 0 // 不缓存位置
          }
        );
      } else {
        alert('您的浏览器不支持地理位置功能');
      }
    },
    // 点击标记点事件
    onMarkerClick (marker) {
      console.log('点击',marker)
      this.selectedMarker = marker;
      this.isInfoWindowVisible = true;
    },
    onInfoWindowClose () {
      console.log('关闭')
      this.isInfoWindowVisible = false;
      this.selectedMarker = null; // 清除选中的标记
    },
    navigateToLocation(marker) {
      // this.center = marker.position;
      // this.zoom = 12;
      console.log('marker', marker)
      window.open('https://www.baidu.com/', '_blank', 'noopener,noreferrer');
      this.isInfoWindowVisible = false;
      this.selectedMarker = null; // 同时清除选中状态
    }
  },
  mounted () {
    // 页面加载时尝试获取用户位置
    this.getCurrentPosition();
  }
}
</script>

<style scoped>
/* 整体样式 */
.locations {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

/* Banner区域样式 */
.locations-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}

.locations-bg-img {
  width: 100%;
  height: 580px;
}

.locations-bg-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.locations-bg-breadcrumb {
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}

.locations-bg-breadcrumb .breadcrumb {
  margin: 0;
  font-size: 1.5rem;
}

.locations-bg-breadcrumb .breadcrumb a {
  color: #959595;
  text-decoration: none;
}

.locations-bg-breadcrumb .breadcrumb-item.active {
  font-weight: bold;
  color: #1E1E1E;
}
.locations-bg-position{ 
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}
.locations-bg-information {
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}

.locations-bg-information img {
  width: 100%;
  height: 100%;
}

.locations-title {
  position: absolute;
  top: 37%;
  left: 9%;
  transform: translateY(-50%);
  color: #000;
  z-index: 1;
}

.locations-title h1 {
  font-size: 3.5vw;
  font-weight: bold;
  margin-bottom: 2vw;
}

.locations-title p {
  font-size: 2vw;
  opacity: 0.9;
  margin-bottom: 2vw;
}
.locations .carousel-caption-btn{
  width: 38%;
  height: 4vw;
  border-radius: 10px;
  border: 1px solid #979797;
  font-size: 2rem;
  color: #1E1E1E;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.locations .carousel-caption-btn:hover{
  background: #1e1e1e;
  color: #fff;
}

/* 内容区域样式 */
.locations-content {
  width: 100%;
  padding: 4% 0 6%;
}

/* locations ===================================== */
.home-locations {
  width: 100%;
  margin: 0 auto 0;
  padding-bottom: 10%;
}
.home-locations-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.home-locations-title{
  margin: 0;
  padding: 5% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4vw;
  color: #1E1E1E;
}
.home-locations-titleBottom{
  font-size: 1.5vw;
}
.home-locations-cont{
  
}
.home-locations-map{
  width: 100%;
  height: 600px;
  /* border: 1px solid #000000; */
  position: relative;
  display: flex;
  gap: 1vw;
}
.home-locations-map-item{
  width: 50%;
  height: 100%;
}
.home-locations-map-item-list{
  width: 50%;
}
.locations-list{
  width: 100%;
  height: 100%;
  padding: 0% 2% 0 0 ;
  overflow-y: auto;
}
.locations-list::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  border-radius: 10px;
}
.locations-list::-webkit-scrollbar {
  width: 8px;       /* 竖向滚动条宽度 */
  height: 10px;      /* 横向滚动条高度 */
  background: transparent; /* 轨道背景色 */
}
.locations-list::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 5px;
  border: 2px solid transparent; /* 透明边框增强视觉效果 */
  background-clip: content-box;  /* 避免背景色溢出 */
}

/* 滑块悬停状态 */
.locations-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条角落 */
.locations-list::-webkit-scrollbar-corner {
  background: transparent;
}



.locations-list-card{
  width: 100%;
  height: 18%;
  margin-bottom: 2%;
  border-radius: 10px;
}

.home-locations-map .map-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.home-locations-map .info-window-content {
  padding: 10px;
  font-size: 14px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 2%;
  align-items: center;
}
.info-window-avater{
  width: 80px;
  height: 80px;
}
.info-window-avater img{ 
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.home-locations-map .info-window-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.home-locations-map .close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.home-locations-map .close-button:hover {
  color: #333;
}

.home-locations-map .info-window-body {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.home-locations-map .info-window-footer {
  text-align: right;
}

.home-locations-map .info-window-footer button {
  padding: 0.2vw 0.3vw;
  background-color: #1e1e1e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.5vw;
}

.home-locations-map .info-window-footer button:hover {
  background-color: #000;
}
/* locations end ===================================== */
.home-locations-map-item-list .info-window-card-content {
  font-size: 1.2vw;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 2%;
  align-items: center;
}
.home-locations-map-item-list .info-window-card-avater{
  width: 4vw;
  height: 4vw;
}
.home-locations-map-item-list .info-window-card-avater img{ 
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.info-window-card-titleCont h5{
  font-size: 1.2vw;
  color: #1e1e1e;
  margin-bottom: 0.1vw;
}
.info-window-card-titleCont p{
  font-size: 1vw;
  color: #959595;
  margin: 0;
}
.home-locations-map-item-list .info-window-card-body {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
}

.home-locations-map-item-list .info-window-card-footer {
  text-align: right;
}

.home-locations-map-item-list .info-window-card-footer button {
  padding: 0.2vw 0.6vw;
  background-color: #1e1e1e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.5vw;
}

.home-locations-map-item-list .info-window-card-footer button:hover {
  background-color: #000;
}
</style>

